/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BooleanApiResponse } from '../../models/boolean-api-response';

export interface CheckExceptionAsync$Params {
  Type?: number;
}

export function checkExceptionAsync(http: HttpClient, rootUrl: string, params?: CheckExceptionAsync$Params, context?: HttpContext): Observable<StrictHttpResponse<BooleanApiResponse>> {
  const rb = new RequestBuilder(rootUrl, checkExceptionAsync.PATH, 'get');
  if (params) {
    rb.query('Type', params.Type, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BooleanApiResponse>;
    })
  );
}

checkExceptionAsync.PATH = '/api/health-check/exception';
